import { render } from "./AddTrainingForm.vue?vue&type=template&id=4a81984f&scoped=true"
import script from "./AddTrainingForm.vue?vue&type=script&lang=js"
export * from "./AddTrainingForm.vue?vue&type=script&lang=js"

import "./AddTrainingForm.vue?vue&type=style&index=0&id=4a81984f&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a81984f"]])

export default __exports__